import React from 'react'
import { motion } from 'framer-motion'
import { CheckCircle, Sparkles, Heart } from 'lucide-react'

export default function SuccessAnimation() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] space-y-8">
      {/* Main Success Icon */}
      <motion.div
        className="relative"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ 
          type: "spring", 
          stiffness: 200, 
          damping: 10,
          duration: 0.6
        }}
      >
        <motion.div
          className="w-32 h-32 bg-gradient-to-br from-purple-400 to-emerald-500 rounded-full flex items-center justify-center shadow-2xl"
          animate={{ 
            boxShadow: [
              "0 0 0 0 rgba(34, 197, 94, 0.4)",
              "0 0 0 20px rgba(34, 197, 94, 0)",
              "0 0 0 0 rgba(34, 197, 94, 0)"
            ]
          }}
          transition={{ 
            duration: 2,
            repeat: Infinity
          }}
        >
          <CheckCircle className="w-16 h-16 text-white" />
        </motion.div>

        {/* Floating Sparkles */}
        {[...Array(6)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-4 h-4"
            style={{
              top: `${20 + Math.sin(i * 60 * Math.PI / 180) * 60}px`,
              left: `${20 + Math.cos(i * 60 * Math.PI / 180) * 60}px`,
            }}
            initial={{ scale: 0, opacity: 0 }}
            animate={{ 
              scale: [0, 1, 0],
              opacity: [0, 1, 0],
              rotate: [0, 180, 360]
            }}
            transition={{ 
              duration: 2,
              delay: 0.3 + i * 0.1,
              repeat: Infinity,
              repeatDelay: 1
            }}
          >
            <Sparkles className="w-4 h-4 text-yellow-400" />
          </motion.div>
        ))}
      </motion.div>

      {/* Success Text */}
      <motion.div
        className="text-center space-y-4"
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.6 }}
      >
        <motion.h2
          className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-emerald-600 bg-clip-text text-transparent"
          animate={{ scale: [1, 1.05, 1] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          Perfetto! 🎉
        </motion.h2>
        
        <motion.p
          className="text-gray-600 text-lg max-w-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          Il tuo momento è stato salvato con successo nel tuo viaggio emotivo
        </motion.p>
      </motion.div>

      {/* Floating Hearts */}
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(8)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            initial={{ 
              scale: 0, 
              opacity: 0,
              y: 50
            }}
            animate={{ 
              scale: [0, 1, 0],
              opacity: [0, 0.6, 0],
              y: [50, -50, -100]
            }}
            transition={{ 
              duration: 3,
              delay: Math.random() * 2,
              repeat: Infinity,
              repeatDelay: Math.random() * 3
            }}
          >
            <Heart className="w-6 h-6 text-pink-400" />
          </motion.div>
        ))}
      </div>

      {/* Progress Indicator */}
      <motion.div
        className="w-64 h-2 bg-gray-200 rounded-full overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8 }}
      >
        <motion.div
          className="h-full bg-gradient-to-r from-purple-400 to-emerald-500 rounded-full"
          initial={{ width: 0 }}
          animate={{ width: "100%" }}
          transition={{ 
            duration: 1.5,
            delay: 0.8,
            ease: "easeOut"
          }}
        />
      </motion.div>

      <motion.p
        className="text-sm text-gray-500 text-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
      >
        Tornando alla home... ✨
      </motion.p>
    </div>
  )
}